var exports = {
  "I": "FaqSection__ixAIMQ",
};

module.exports = exports;
